/**
 * Hub entry point — includes superadmin portal + admin + all features.
 * Used by: vite.config.ts when VITE_BUILD_MODE=hub
 */
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import AppHub from './AppHub'
import { AuthProvider } from './contexts/AuthContext'
import { SettingsProvider } from './contexts/SettingsContext'
import { RbacProvider } from './contexts/RbacContext'
import AuthAwareIndustryProvider from './providers/AuthAwareIndustryProvider'
import { ErrorBoundary } from './components/ErrorBoundary'
import './i18n/config'  // Phase 8D Wave 1 — registers i18next + LanguageDetector
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <RbacProvider>
            <SettingsProvider>
              <AuthAwareIndustryProvider>
                <AppHub />
              </AuthAwareIndustryProvider>
            </SettingsProvider>
          </RbacProvider>
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
)
